import { nanoid } from 'nanoid';

import { onTextToSpeechChunkReceivedSubscriptionRequest } from '../../requests/on-text-to-speech-chunk-received.susbscription.ts';

import { AudioMediaSourceUtil } from './audio-media-source.util.ts';
import { getTextToSpeechChunkProcessorUtil } from './text-to-speech-chunk-processor.util.ts';

export abstract class BaseSpeechUtil<T extends { id: string }> {
  protected constructor(private readonly textToSpeechChunkProcessorUtil = getTextToSpeechChunkProcessorUtil()) {}

  protected abstract onConnected(params: T): Promise<void>;

  public createAudioMediaSource(params: Omit<T, 'id'>, onAudioPlay?: () => void): AudioMediaSourceUtil {
    const id = nanoid();
    const initializationPromise = this.textToSpeechChunkProcessorUtil.initializeSubscriptionData(id);

    const audioMediaSourceUtil = new AudioMediaSourceUtil(async (): Promise<void> => {
      const subscription = await onTextToSpeechChunkReceivedSubscriptionRequest(
        { id },
        {
          onConnected: async () => {
            await this.onConnected({ ...params, id } as T);
          },
          onError: (error) => {
            audioMediaSourceUtil.error(error);
          },
          onData: async (data) => {
            await initializationPromise;
            getTextToSpeechChunkProcessorUtil().processChunk(subscription, audioMediaSourceUtil, data);
          },
        }
      );
    }, onAudioPlay);

    return audioMediaSourceUtil;
  }
}
